import { useUserStore } from '@unifyapps/carbon/auth/UserStoreProvider';

export function useIsUserLoggedIn(): boolean {
  const isLoggedIn = useUserStore().hooks.useIsLoggedIn();
  return Boolean(isLoggedIn);
}
